<script>
import List from "@/components/molecules/list";
import Icon from "@/components/atoms/icon";
import ListItemNavigation from "@/components/molecules/list-item-navigation";
import { headerMenuProps, useHeaderMenu } from "./mixin";

export default {
  name: "HeaderMenuMobile",
  components: {
    ListItemNavigation,
    List,
    Icon
  },
  props: {
    ...headerMenuProps(),
    coinDesMarquesIds: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  emits: ["selectCategory"],
  setup(props) {
    const { menuCodes, categoriesWithoutHeader } = useHeaderMenu(props);
    return { menuCodes, categoriesWithoutHeader };
  },
  methods: {
    selectCategory(category) {
      this.$emit("selectCategory", category);
    }
  }
};
</script>

<template>
  <div class="c-header-menu-mobile">
    <List>
      <template
        v-for="(category, index) in categoriesWithoutHeader"
        :key="category.id"
      >
        <template v-if="!category.attributes.hidden_on_mobile">
          <ListItemNavigation
            v-if="category.id === boutiqueExcluWebId"
            class="c-header-menu__nav u-full-width"
            :variant="index === 0 ? 'active' : null"
            :to="category.attributes.slug"
          >
            <span class="u-flex u-flex-align-center">
              <Icon
                name="exclu-web"
                variant="black"
                size="sm"
                class="u-mr-xs"
              />
              {{ category.attributes.libelle }}
            </span>
            <span
              style="background-color: #008B94"
              class="c-header-menu-mobile__nav-button-line"
            ></span>
          </ListItemNavigation>
          <ListItemNavigation
            v-else-if="category.attributes.children"
            :icon-name="index === 0 ? 'basket' : null"
            :icon-color="index === 0 ? 'white' : null"
            icon-size="sm"
            :no-border="index == categoriesWithoutHeader.length - 1"
            class="c-header-menu__nav u-full-width"
            :variant="index === 0 ? 'active' : null"
            @click="selectCategory(category)"
          >
            {{ category.attributes.libelle }}
          </ListItemNavigation>
          <ListItemNavigation
            v-else
            :icon-name="index === 0 ? 'basket' : null"
            :icon-color="index === 0 ? 'white' : null"
            icon-size="sm"
            :no-border="index == categoriesWithoutHeader.length - 1"
            class="c-header-menu__nav u-full-width"
            :variant="index === 0 ? 'active' : null"
            :to="category.attributes.slug"
          >
            {{ category.attributes.libelle }}
          </ListItemNavigation>
        </template>
      </template>
    </List>
  </div>
</template>

<style lang="scss" scoped>
.c-header-menu-mobile__nav {
  &:last-child {
    &:after {
      display: none;
    }
  }
}
.c-header-menu-mobile__nav-button-line {
  position: absolute;
  bottom: 0rem;
  height: 2.4rem;
  width: 0.4rem;
  border-radius: 0.4rem;
  left: -1.2rem;
  top: 50%;
  transform: translateY(-50%);
  background-color: color(primary);
}
</style>
